<template>
  <div class="borderConfig chartConfig_viewDP">
    <div class="chartDivConfig checkViewConfig">
      <el-checkbox v-model="back.checkedVal1" @change="lunbo()">是否开启页面轮播</el-checkbox>
    </div>
    <div class="chartDivConfig selViewConfig minInput" v-if="back.checkedVal1">
      <span class="span_til">轮播方式</span>
      <el-select v-model="back.isOutIn" placeholder="请选择轮播方式" :popper-append-to-body="false">
        <el-option :label="item" :value="item" :key="item" v-for="item in list"></el-option>
      </el-select>
    </div>
    <div class="chartDivConfig selViewConfig minInput" v-if="back.checkedVal1&&back.isOutIn==='系统页面'">
      <span class="span_til">系统页面</span>
      <el-select v-model="back.rotationID" placeholder="请选择跳转页" :popper-append-to-body="false">
        <el-option v-for="item in groupDpList" :key="item.id" :label="item.screenPageName" :value="item.id" id="systemID">
        </el-option>
      </el-select>
    </div>
    <div class="chartDivConfig textViewConfig" v-if="back.checkedVal1&&back.isOutIn==='外部链接'">
      <span class="span_til">URL地址</span>
      <el-input v-model="back.outLinkText" type="textarea" autosize></el-input>
    </div>

    <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="back.checkedVal1&&back.checkedVal1">
      <span class="span_til">更新频率</span>
      <el-input v-model="back.rotationTime" type="number" min="0"></el-input>
      <div class="unit">s</div>
    </div>
  </div>
</template>

<script>
/** xiwenbo
 * 
 @author xiaoye
 @date 2020/5/25 4:01 下午
 */

export default {
  name: 'borderConfig',
  components: {},
  props: {},
  computed: {
    back() {
      return this.$store.state.designer.nowChart.pageParam.back;
    },
    groupDpList() {
      let grpList = this.$store.state.designer.groupDpList;
      grpList.push({
        "id": null,
        "screenPageName": '空',
      })
      return grpList
    },
    
  },
  data() {
    return {
      list: ["系统页面", "外部链接"],
    }
  },
  methods: {
    lunbo(){
      if(!this.back.checkedVal1){
        this.back.rotationTime = 0;
        this.back.rotationID = "";
        this.back.outLinkText = "";
        this.back.isOutIn = 0;
      }
    }
    
    // changeVal() {
    //   this.$emit('changeVal', this.checked)
    // },
    // changeLBway() {
    //   this.$emit('changeLBway', this.listType)
    // },
    // changeXTid(e) {
    //   this.$emit('changeXTid', e)
    // },
    // changeUpdateS() {
    //   this.$emit('changeUpdateS', this.updateFrequency)
    // },
    // changeUrlAds() {
    //   this.$emit('changeUrlAds', this.urlAddress)
    // }
  },
  mounted() {
  },
  destroyed() {

  }
}
</script>

<style lang="less">
.borderConfig {
  .minInput {
    > span {
      width: 40px;
    }

    > .el-input {
      width: 50%;
    }

    > .el-select {
      width: 50%;
    }
  }
}
</style>